import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Consultations from '@services/Consultations'
import './styles.scss'
import { getParamId } from '@utilities/mdHandler'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import { ProfessionalGroupsRedux } from '@modules/admin/groups/GroupsProfessionalForm'
import Loading from '@modules/core/components/Loading'
import { history } from '@services/History'
import { useTranslation } from 'react-i18next'

const GroupsProfessionalUpdate = (props) => {
  const id = getParamId(props)
  const client = Consultations.teams
  const [initialValues, setInitialValues] = useState({
    name: null,
    professionals: [],
    //  company_groups:[],
  })
  const [loading, setLoading] = useState(!!id)
  const { t } = useTranslation()

  const submit = async (values) => {
    //todo:add parse request body if its necessary
    const requestBody = {
      ...values,
      provider_id: 1,
      //   company_groups_ids:values?.company_groups?.map(comp =>comp.id),
      professionals_ids: values.professionals.map((prof) => prof.id),
    }
    try {
      if (id) client.update(id, requestBody)
      else client.store(requestBody)
      history.push('/groups')
    } catch (e) {
      console.error(e.message)
    }
  }
  const fetchData = async () => {
    setLoading(true)
    try {
      const { data } = await client.show(id)
      setInitialValues(data)
    } catch (e) {
      console.error(e.message)
    }
    setLoading(false)
  }
  useEffect(() => {
    id && fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const titleHeader = id ? t('editProfessionalGroup') : t('newProfessionalGroup')
  let component
  if (loading) component = <Loading isFetching={true} />
  else component = <ProfessionalGroupsRedux initialValues={initialValues} onSubmit={submit} t={t} />

  return (
    <div className="groups-update">
      <DashboardHeader title={titleHeader} total={null}>
        <Link className="btn btn-primary" to={`/groups`}>
          {t('back')}
        </Link>
      </DashboardHeader>
      {component}
    </div>
  )
}
export default GroupsProfessionalUpdate
